import React from "react";
import styled from "styled-components";
import { LoadingState } from "./LoadingState";

const LoadingWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

export const LoadingPage: React.FC = () => (
  <LoadingWrap>
    <LoadingState sammy />
  </LoadingWrap>
);
